import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss' // global css

import './assets/icons' // icon

import CustomForm from '@/components/customForm'
import CustomDescriptions from '@/components/customDescriptions'
import StatusTag from '@/components/StatusTag/StatusTag.vue'

Vue.use(ElementUI);
Vue.config.productionTip = false;

// 全局组件挂载
Vue.component('CustomForm', CustomForm)
Vue.component('CustomDescriptions', CustomDescriptions)
Vue.component('StatusTag', StatusTag)

Vue.prototype.$pageSizeList = [10, 20, 30, 50, 80, 100, 200, 500]
init();
async function init() {
  await store.dispatch('user/setGlobalConfig');
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

}





